













import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { irUsdTableMap } from '@/common/constant.js';

@Component({
  components: {}
})
class USDIRBitableReport extends Vue {
  irUsdTable: string = '';

  created() {
    this.irUsdTable = irUsdTableMap[window.location.host];
  }
}
export default USDIRBitableReport;
